import React, { Component } from "react"
import { Grid, IconButton, Menu, MenuItem, MenuList } from "@material-ui/core"
import { Menu as MenuIcon, Clear } from "@material-ui/icons"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import LinkButton from "../../atoms/LinkButton"
import { withStyles } from "@material-ui/core/styles"
import { colors } from "../../constants"

const Text = styled.span({
  fontFamily: "Avenir Next",
  flexGrow: 1,
  color: colors.brand,
  fontSize: "16px",
})

const Line = styled(Grid)({
  width: "100%",
  height: "1px",
  background: "gray",
  margin: "0 auto",
  animation: "0.5s shrink forwards",
  opacity: 0.2,
})

const menus = [
  {
    label: "片平ゼミとは",
    to: "seminar",
  },
  {
    label: "人物紹介",
    to: "members",
  },
  {
    label: "ゼミ活動",
    to: "projects",
  },
  {
    label: "選考情報",
    to: "selection",
  },
]

function MobileHeaderMenu({ handleClose, open }) {
  return (
    <Menu
      open={open}
      onClose={handleClose}
      anchorPosition={{
        top: 54,
        right: 0,
      }}
      anchorReference={"anchorPosition"}
      PaperProps={{
        style: {
          width: "100%",
          borderRadius: 0,
          maxWidth: "none",
        },
      }}
      MenuListProps={{
        padding: "0px",
      }}
      PopoverClasses={{
        paddingTop: 0,
        paddingBottom: 0,
      }}
      style={{ paddingTop: 0, paddingBottom: 0 }}
    >
      {menus.map((menu, index) => (
        <MenuItem
          key={index}
          delay={`${index * 0.1}s`}
          onClick={handleClose}
          style={{ display: "contents" }}
        >
          <GridWrapper
            justifyContent={"left"}
            alignItems={"center"}
            style={{ paddingLeft: "10px", height: "50px" }}
          >
            <LinkButton
              to={menu.to}
              style={{ textAlign: "left", width: "100%" }}
            >
              <Text>{menu.label}</Text>
            </LinkButton>
          </GridWrapper>
          {/* <Line /> */}
        </MenuItem>
      ))}
    </Menu>
  )
}

export default MobileHeaderMenu
